import React, {useState} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";

import CustomSizeList from "./customSize/CustomSizeList";
import CustomSizeSwapButton from "./customSize/CustomSizeSwapButton";
import Switcher from "../../../ui/Switcher";
import sqftShape from "../../../canvas/core/shapes/sqftShape";

const SectionCustomSize = (props) => {
  const {shape} = props
  const [isEnabled, setEnabled] = useState(shape.shouldAddCabinetBox);
  const onChange = () => {
    setEnabled(!isEnabled);
    shape.setShouldAddCabinetBox(!isEnabled);
  }

  return (
    <div className="sr__section sr__custom-size">
      <div className="sr__section-title">
        Enable Custom Size
        <span>
          <Switcher value={isEnabled} onChange={onChange} />
        </span>
      </div>
      <CustomSizeList shape={shape} isEnabled={isEnabled}/>
      <CustomSizeSwapButton shape={shape}/>
    </div>
  )
};

SectionCustomSize.propTypes = {
  shape: PropTypes.instanceOf(sqftShape)
};

const mapStateToProps = (store) => {
  return {
    menuOpened: store.sqftMenuState.menuOpened,
  };
};

const mapDispatchToProps = {
};


export default connect(mapStateToProps, mapDispatchToProps)(SectionCustomSize);
